import React from 'react'
import { Button, Modal } from 'semantic-ui-react'
import { resetBatchData } from '../../redux/actions/ui'

interface Props {
  warningActive: boolean
  setWarningActive: (status: boolean) => void
  handleDownloadReport: () => void
  dispatch: any
}

export const FinishWarningModal = (props: Props) => {
  const { warningActive, setWarningActive, dispatch, handleDownloadReport } = props
  return (
    <Modal size="mini" open={warningActive} onClose={() => setWarningActive(false)}>
      <Modal.Header>Finished all alias assignments?</Modal.Header>
      <Modal.Content>
        <p>
          Batch lookup will be reset. You can download the assignment report
          <span style={{ color: '#4183c4', cursor: 'pointer' }} onClick={handleDownloadReport}>
            {' '}
            here
          </span>
          .
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button
          onClick={() => {
            setWarningActive(false)
          }}
        >
          No
        </Button>
        <Button
          primary
          content="Yes"
          onClick={() => {
            setWarningActive(false)
            dispatch(resetBatchData())
          }}
        />
      </Modal.Actions>
    </Modal>
  )
}
